// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-selector {
    position: relative;
    display: inline-flex;
}

.property-selector__trigger {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(0, 0, 0, 0.2);
    color: #f0f0f0;
    padding: 6px 12px 6px 10px;
    border-radius: 10px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    cursor: pointer;
    max-width: 320px;
    transition: border-color 0.2s ease, background 0.2s ease;
}

.property-selector__trigger:hover {
    border-color: rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.08);
}

.property-selector__mode-icon {
    width: 26px;
    height: 26px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: rgba(192, 159, 83, 0.18);
}

.property-selector__mode-icon img {
    width: 16px;
    height: 16px;
    filter: brightness(0) saturate(100%) invert(78%) sepia(24%) saturate(500%) hue-rotate(357deg) brightness(95%);
}

.property-selector__trigger-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
    text-align: left;
    line-height: 1.25;
}

.property-selector__trigger-context {
    font-size: 0.625rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.property-selector__trigger-domain {
    font-size: 0.8125rem;
    font-weight: 600;
    color: #f0f0f0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.property-selector__caret {
    width: 7px;
    height: 7px;
    flex-shrink: 0;
    border-right: 2px solid rgba(255, 255, 255, 0.45);
    border-bottom: 2px solid rgba(255, 255, 255, 0.45);
    transform: rotate(45deg) translateY(-2px);
}

.property-selector__panel {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 220;
    width: min(640px, calc(100vw - 24px));
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: linear-gradient(168deg, rgba(52, 52, 56, 0.98) 0%, rgba(32, 32, 36, 0.99) 100%);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.property-selector__mode-row {
    display: flex;
    gap: 6px;
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.property-selector__mode-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 8px;
    background: transparent;
    color: rgba(255, 255, 255, 0.65);
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.property-selector__mode-btn img {
    width: 16px;
    height: 16px;
    filter: brightness(0) invert(1) opacity(0.65);
}

.property-selector__mode-btn:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
}

.property-selector__mode-btn--active {
    background: rgba(192, 159, 83, 0.16);
    border-color: rgba(192, 159, 83, 0.4);
    color: #f0f0f0;
}

.property-selector__mode-btn--active img {
    filter: brightness(0) saturate(100%) invert(78%) sepia(24%) saturate(500%) hue-rotate(357deg) brightness(95%);
}

.property-selector__org-row {
    position: relative;
    padding: 8px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.property-selector__org-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: none;
    background: transparent;
    color: #f0f0f0;
    font-size: 0.8125rem;
    font-weight: 600;
    padding: 4px 2px;
    cursor: pointer;
    text-align: left;
}

.property-selector__org-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #d0463c;
    color: #fff;
    font-size: 0.6875rem;
    font-weight: 700;
    flex-shrink: 0;
}

.property-selector__org-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.property-selector__org-list {
    position: absolute;
    top: calc(100% + 2px);
    left: 12px;
    right: 12px;
    margin: 0;
    padding: 4px 0;
    list-style: none;
    background: rgba(24, 24, 26, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
    max-height: 220px;
    overflow-y: auto;
    z-index: 5;
}

.property-selector__org-list button {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: none;
    background: transparent;
    color: #e4e4e4;
    font-size: 0.8125rem;
    padding: 8px 12px;
    cursor: pointer;
    text-align: left;
}

.property-selector__org-list button:hover {
    background: rgba(192, 159, 83, 0.14);
    color: #fff;
}

.property-selector__org-list img {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    object-fit: contain;
}

.property-selector__search-row {
    padding: 10px 12px 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.15);
}

.property-selector__search {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.25);
    color: #f0f0f0;
    font-size: 0.8125rem;
    font-family: inherit;
}

.property-selector__search::placeholder {
    color: rgba(255, 255, 255, 0.35);
}

.property-selector__search:focus {
    outline: none;
    border-color: rgba(192, 159, 83, 0.45);
    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.15);
}

.property-selector__tabs {
    display: flex;
    gap: 4px;
    padding: 8px 12px 0;
}

.property-selector__tab {
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.55);
    font-size: 0.75rem;
    font-weight: 600;
    padding: 6px 10px;
    border-bottom: 2px solid transparent;
    cursor: pointer;
}

.property-selector__tab:hover {
    color: #fff;
}

.property-selector__tab--active {
    color: #c0a053;
    border-bottom-color: #c0a053;
}

.property-selector__columns {
    display: grid;
    grid-template-columns: 200px 1fr;
    height: min(60vh, 380px);
    overflow: hidden;
}

.property-selector__col {
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.property-selector__col:last-child {
    border-right: none;
}

.property-selector__col-title {
    padding: 10px 14px 6px;
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.85);
    flex-shrink: 0;
}

.property-selector__list {
    margin: 0;
    padding: 0 6px 8px;
    list-style: none;
    overflow-y: auto;
    flex: 1;
}

.property-selector__row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: none;
    background: transparent;
    color: #e4e4e4;
    font-size: 0.8125rem;
    padding: 8px 8px;
    border-radius: 8px;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s ease, color 0.15s ease;
}

.property-selector__row:hover {
    background: rgba(192, 159, 83, 0.14);
    color: #fff;
}

.property-selector__row--active {
    background: rgba(192, 159, 83, 0.2);
    color: #fff;
}

.property-selector__ws-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: rgba(192, 159, 83, 0.2);
    border: 1px solid rgba(192, 159, 83, 0.35);
    color: #c0a053;
    font-size: 0.6875rem;
    font-weight: 700;
}

.property-selector__ws-icon--all {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.16);
    color: rgba(255, 255, 255, 0.8);
}

.property-selector__row-text {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
}

.property-selector__row-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.property-selector__row-name--mono {
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    flex: 1;
}

.property-selector__row-sub {
    font-size: 0.6875rem;
    color: rgba(192, 159, 83, 0.85);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.property-selector__row--domain {
    justify-content: flex-start;
}

.property-selector__check {
    color: #7dd590;
    font-size: 0.75rem;
    flex-shrink: 0;
}

.property-selector__favicon {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    object-fit: contain;
    flex-shrink: 0;
}

.property-selector__verify {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 0.5625rem;
    font-weight: 700;
    flex-shrink: 0;
}

.property-selector__verify--verified {
    background: rgba(80, 180, 100, 0.2);
    border: 1px solid rgba(80, 180, 100, 0.4);
    color: #7dd590;
}

.property-selector__verify--unverified {
    background: rgba(220, 160, 60, 0.2);
    border: 1px solid rgba(220, 160, 60, 0.4);
    color: #e8c76a;
}

.property-selector__verify--expired {
    background: rgba(220, 100, 80, 0.2);
    border: 1px solid rgba(220, 100, 80, 0.4);
    color: #f0a8a0;
}

.property-selector__analytics-badge {
    color: #7dd590;
    font-size: 0.5rem;
    flex-shrink: 0;
    line-height: 1;
}

/* Domain has no analytics site key yet — still fully clickable (to open and
   enable it), just visually de-emphasised so the eye lands on active ones. */
.property-selector__row--no-analytics {
    opacity: 0.55;
}

.property-selector__row--no-analytics:hover {
    opacity: 0.85;
}

.property-selector__primary-tag {
    font-size: 0.5625rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 2px 5px;
    border-radius: 3px;
    background: rgba(192, 159, 83, 0.2);
    border: 1px solid rgba(192, 159, 83, 0.35);
    color: #c0a053;
    flex-shrink: 0;
}

.property-selector__star {
    margin-left: auto;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.9rem;
    line-height: 1;
    cursor: pointer;
    padding: 2px;
    flex-shrink: 0;
}

.property-selector__star:hover {
    color: rgba(192, 159, 83, 0.8);
}

.property-selector__star--active {
    color: #c0a053;
}

.property-selector__empty {
    padding: 14px 12px;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.4);
    text-align: center;
}

@media screen and (min-width: 320px) and (max-width: 900px) {
    .property-selector {
        width: 100%;
    }

    .property-selector__trigger {
        width: 100%;
        max-width: none;
    }

    .property-selector__panel {
        left: 0;
        right: 0;
        width: 100%;
    }

    .property-selector__columns {
        grid-template-columns: 1fr;
        grid-auto-rows: min-content;
        max-height: min(70vh, 480px);
        overflow-y: auto;
    }

    .property-selector__col {
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/PropertySelector.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,2CAA2C;IAC3C,8BAA8B;IAC9B,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,gGAAgG;IAChG,eAAe;IACf,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6GAA6G;AACjH;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,iDAAiD;IACjD,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2FAA2F;IAC3F,2CAA2C;IAC3C,mBAAmB;IACnB,oFAAoF;AACxF;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,6GAA6G;AACjH;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kCAAkC;IAClC,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kDAAkD;IAClD,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;IACd,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,0CAA0C;IAC1C,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gFAAgF;IAChF,OAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;6EAC6E;AAC7E;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,0CAA0C;IAC1C,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,OAAO;QACP,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,kDAAkD;IACtD;AACJ","sourcesContent":[".property-selector {\n    position: relative;\n    display: inline-flex;\n}\n\n.property-selector__trigger {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(0, 0, 0, 0.2);\n    color: #f0f0f0;\n    padding: 6px 12px 6px 10px;\n    border-radius: 10px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n    cursor: pointer;\n    max-width: 320px;\n    transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.property-selector__trigger:hover {\n    border-color: rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.08);\n}\n\n.property-selector__mode-icon {\n    width: 26px;\n    height: 26px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    background: rgba(192, 159, 83, 0.18);\n}\n\n.property-selector__mode-icon img {\n    width: 16px;\n    height: 16px;\n    filter: brightness(0) saturate(100%) invert(78%) sepia(24%) saturate(500%) hue-rotate(357deg) brightness(95%);\n}\n\n.property-selector__trigger-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    text-align: left;\n    line-height: 1.25;\n}\n\n.property-selector__trigger-context {\n    font-size: 0.625rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.5);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.property-selector__trigger-domain {\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: #f0f0f0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.property-selector__caret {\n    width: 7px;\n    height: 7px;\n    flex-shrink: 0;\n    border-right: 2px solid rgba(255, 255, 255, 0.45);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.45);\n    transform: rotate(45deg) translateY(-2px);\n}\n\n.property-selector__panel {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    z-index: 220;\n    width: min(640px, calc(100vw - 24px));\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    background: linear-gradient(168deg, rgba(52, 52, 56, 0.98) 0%, rgba(32, 32, 36, 0.99) 100%);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 12px;\n    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.property-selector__mode-row {\n    display: flex;\n    gap: 6px;\n    padding: 10px 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.property-selector__mode-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    background: transparent;\n    color: rgba(255, 255, 255, 0.65);\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.property-selector__mode-btn img {\n    width: 16px;\n    height: 16px;\n    filter: brightness(0) invert(1) opacity(0.65);\n}\n\n.property-selector__mode-btn:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: #fff;\n}\n\n.property-selector__mode-btn--active {\n    background: rgba(192, 159, 83, 0.16);\n    border-color: rgba(192, 159, 83, 0.4);\n    color: #f0f0f0;\n}\n\n.property-selector__mode-btn--active img {\n    filter: brightness(0) saturate(100%) invert(78%) sepia(24%) saturate(500%) hue-rotate(357deg) brightness(95%);\n}\n\n.property-selector__org-row {\n    position: relative;\n    padding: 8px 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.property-selector__org-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    border: none;\n    background: transparent;\n    color: #f0f0f0;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    padding: 4px 2px;\n    cursor: pointer;\n    text-align: left;\n}\n\n.property-selector__org-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #d0463c;\n    color: #fff;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.property-selector__org-name {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.property-selector__org-list {\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 12px;\n    right: 12px;\n    margin: 0;\n    padding: 4px 0;\n    list-style: none;\n    background: rgba(24, 24, 26, 0.98);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);\n    max-height: 220px;\n    overflow-y: auto;\n    z-index: 5;\n}\n\n.property-selector__org-list button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    border: none;\n    background: transparent;\n    color: #e4e4e4;\n    font-size: 0.8125rem;\n    padding: 8px 12px;\n    cursor: pointer;\n    text-align: left;\n}\n\n.property-selector__org-list button:hover {\n    background: rgba(192, 159, 83, 0.14);\n    color: #fff;\n}\n\n.property-selector__org-list img {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    object-fit: contain;\n}\n\n.property-selector__search-row {\n    padding: 10px 12px 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.15);\n}\n\n.property-selector__search {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 8px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.25);\n    color: #f0f0f0;\n    font-size: 0.8125rem;\n    font-family: inherit;\n}\n\n.property-selector__search::placeholder {\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.property-selector__search:focus {\n    outline: none;\n    border-color: rgba(192, 159, 83, 0.45);\n    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.15);\n}\n\n.property-selector__tabs {\n    display: flex;\n    gap: 4px;\n    padding: 8px 12px 0;\n}\n\n.property-selector__tab {\n    border: none;\n    background: transparent;\n    color: rgba(255, 255, 255, 0.55);\n    font-size: 0.75rem;\n    font-weight: 600;\n    padding: 6px 10px;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n}\n\n.property-selector__tab:hover {\n    color: #fff;\n}\n\n.property-selector__tab--active {\n    color: #c0a053;\n    border-bottom-color: #c0a053;\n}\n\n.property-selector__columns {\n    display: grid;\n    grid-template-columns: 200px 1fr;\n    height: min(60vh, 380px);\n    overflow: hidden;\n}\n\n.property-selector__col {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    border-right: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.property-selector__col:last-child {\n    border-right: none;\n}\n\n.property-selector__col-title {\n    padding: 10px 14px 6px;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.85);\n    flex-shrink: 0;\n}\n\n.property-selector__list {\n    margin: 0;\n    padding: 0 6px 8px;\n    list-style: none;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.property-selector__row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    border: none;\n    background: transparent;\n    color: #e4e4e4;\n    font-size: 0.8125rem;\n    padding: 8px 8px;\n    border-radius: 8px;\n    cursor: pointer;\n    text-align: left;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.property-selector__row:hover {\n    background: rgba(192, 159, 83, 0.14);\n    color: #fff;\n}\n\n.property-selector__row--active {\n    background: rgba(192, 159, 83, 0.2);\n    color: #fff;\n}\n\n.property-selector__ws-icon {\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    background: rgba(192, 159, 83, 0.2);\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    color: #c0a053;\n    font-size: 0.6875rem;\n    font-weight: 700;\n}\n\n.property-selector__ws-icon--all {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.16);\n    color: rgba(255, 255, 255, 0.8);\n}\n\n.property-selector__row-text {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n}\n\n.property-selector__row-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.property-selector__row-name--mono {\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    flex: 1;\n}\n\n.property-selector__row-sub {\n    font-size: 0.6875rem;\n    color: rgba(192, 159, 83, 0.85);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.property-selector__row--domain {\n    justify-content: flex-start;\n}\n\n.property-selector__check {\n    color: #7dd590;\n    font-size: 0.75rem;\n    flex-shrink: 0;\n}\n\n.property-selector__favicon {\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.property-selector__verify {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    font-size: 0.5625rem;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.property-selector__verify--verified {\n    background: rgba(80, 180, 100, 0.2);\n    border: 1px solid rgba(80, 180, 100, 0.4);\n    color: #7dd590;\n}\n\n.property-selector__verify--unverified {\n    background: rgba(220, 160, 60, 0.2);\n    border: 1px solid rgba(220, 160, 60, 0.4);\n    color: #e8c76a;\n}\n\n.property-selector__verify--expired {\n    background: rgba(220, 100, 80, 0.2);\n    border: 1px solid rgba(220, 100, 80, 0.4);\n    color: #f0a8a0;\n}\n\n.property-selector__analytics-badge {\n    color: #7dd590;\n    font-size: 0.5rem;\n    flex-shrink: 0;\n    line-height: 1;\n}\n\n/* Domain has no analytics site key yet — still fully clickable (to open and\n   enable it), just visually de-emphasised so the eye lands on active ones. */\n.property-selector__row--no-analytics {\n    opacity: 0.55;\n}\n\n.property-selector__row--no-analytics:hover {\n    opacity: 0.85;\n}\n\n.property-selector__primary-tag {\n    font-size: 0.5625rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    padding: 2px 5px;\n    border-radius: 3px;\n    background: rgba(192, 159, 83, 0.2);\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    color: #c0a053;\n    flex-shrink: 0;\n}\n\n.property-selector__star {\n    margin-left: auto;\n    border: none;\n    background: transparent;\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 0.9rem;\n    line-height: 1;\n    cursor: pointer;\n    padding: 2px;\n    flex-shrink: 0;\n}\n\n.property-selector__star:hover {\n    color: rgba(192, 159, 83, 0.8);\n}\n\n.property-selector__star--active {\n    color: #c0a053;\n}\n\n.property-selector__empty {\n    padding: 14px 12px;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.4);\n    text-align: center;\n}\n\n@media screen and (min-width: 320px) and (max-width: 900px) {\n    .property-selector {\n        width: 100%;\n    }\n\n    .property-selector__trigger {\n        width: 100%;\n        max-width: none;\n    }\n\n    .property-selector__panel {\n        left: 0;\n        right: 0;\n        width: 100%;\n    }\n\n    .property-selector__columns {\n        grid-template-columns: 1fr;\n        grid-auto-rows: min-content;\n        max-height: min(70vh, 480px);\n        overflow-y: auto;\n    }\n\n    .property-selector__col {\n        border-right: none;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
